import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {PaperChatFilterType} from '../../../chat/dto/paper-chat';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/project';


  downloadCSV(projectId: number, filter: PaperChatFilterType): Observable<Blob> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    let params = new HttpParams().set('filter', filter.toString());

    return this.http.get(`${this.apiUrl}/${projectId}/research/paper/export/csv`, {params: params, responseType: 'blob'});
  }

  downloadBibtex(projectId: number, filter: PaperChatFilterType): Observable<Blob> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    let params = new HttpParams().set('filter', filter.toString());

    return this.http.get(`${this.apiUrl}/${projectId}/research/paper/export/bibtex`, {params: params, responseType: 'blob'});
  }

  saveFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a); // Notwendig für Firefox
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
